// extracted by mini-css-extract-plugin
export default {"content":"Content_content__m8sLA","contentEn":"Content_contentEn__k4q3L"};